import React from 'react'
import * as S from './styles'
import { useTranslation } from 'react-i18next'

const CustomRadiology = () => {
  const { t } = useTranslation()

  return (
    <S.CustomRadiologyContainer>
      {Array.from({ length: 5 }).map((_, idx) => (
        <li>{t(`titles.radiology.${idx + 1}`)}</li>
      ))}
    </S.CustomRadiologyContainer>
  )
}

export default CustomRadiology
